import { render, staticRenderFns } from "./FiltersTreeHeader.vue?vue&type=template&id=a8a8ea6c&lang=pug&"
import script from "./FiltersTreeHeader.vue?vue&type=script&lang=js&"
export * from "./FiltersTreeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports